import React from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Create from "./modal-create-unit";
import { getUnits } from "../../utils";
import { setUnit, setUnits } from "../actions";

import { mapTest } from '../../map.test'

class SelectUnit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      units: [],
    };
    this._setUnit = this._setUnit.bind(this);
  }

  _setDefaultUnit() {
    const { units } = this.state
    for (let x = 0; x < units.length; x++) {
      const unit = units[x]
      if (unit.name.toLowerCase() === "un") {
        this._setUnit(unit)
        return
      }
    }
  }
  _setUnit(unit) {
    this.props.setUnit(unit);
  }
  UNSAFE_componentWillMount() {
    const payload = (units) => {
      units.forEach((unit) => {
        (unit.label = unit.name), (unit.value = unit.id);
      });
      this.setState({ ...this, units });
      this.props.setUnits(units);
      this._setDefaultUnit()
    };
    getUnits(payload);
  }

  render() {
    return (
      <React.Fragment>
        <div className={this.props.noPadding ? "" : "py-3"}>
          <p className={this.props.labelClass || "lead py-0 m-0"}>{this.props.name || "Unidade"}</p>
          <Select
            id={mapTest.createProduct.unit.select}
            isSearchable
            className={this.props.inputClass || "d-inline-block w-75"}
            placeholder={`Selecione a ${this.props.name || "unidade"}`}
            value={this.props.unit}
            onChange={this._setUnit}
            options={this.state.units}   
            id-value={mapTest.createProduct.unit.select}
          > 
          </Select>
          <Create
            name={this.props.name || "Unidade"}
            trigger="icon"
            id={mapTest.createProduct.unit.buttonCreate}
            name={mapTest.createProduct.unit.buttonCreate}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  unit: state.unit,
  units: state.units,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setUnit, setUnits }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SelectUnit);



// WEBPACK FOOTER //
// ./src/components/pages/products/base/unit/index.jsx